<template>
  <div>
    <div>
      <div class="title">修改密码</div>
      <el-form label-width="100px">
        <el-form-item label="新密码" prop="pass">
          <el-input type="password" v-model="pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-form label-width="100px">
        <el-form-item label="钉钉" prop="pass">
          <el-input type="text" disabled v-if="ddid" v-model="ddid" autocomplete="off"></el-input>
          <div id="login_container" v-show="!ddid"></div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="ddid" @click="unbundle()">解绑</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--    {{}}-->
  </div>

</template>
<script>
import {resetPass} from '@/api/login'
import {BoundDD, UnBoundDD} from "@/api/system.admin";
import {getUserInfo, setUserInfo} from "@/utils/auth";

export default {
  data() {
    return {
      pass: '',
      ddid: '',
      loginType: true
    }
  },
  mounted() {
    this.ddid = this.$store.state.user.userInfo.ddid
    // code是登录所需最终参数
    const {code} = this.$route.query
    var href = location.href;
    console.log(href)
    if (code) { //登录接口
      this.handleCodeLogin(code)
    } else {    //钉钉二维码
      this.ddLoginInit()
    }
  },
  created() {
    this.ddid = this.$store.state.user.userInfo.ddid
  },
  methods: {
    ddLoginInit() {
      //钉钉扫码流程：扫码成功登录后会自动跳到这个url页面，url路径会携带code，你拿到这个code，调用登录接口成功就跳转。
      //你的项目页面 http://localhost:8080/login
      let url = encodeURIComponent(process.env.VUE_APP_BOUND_URL);
      // appid 找后端要 dingypabtdsjyhxe3ent
      let appid = process.env.VUE_APP_APPID
      // 钉钉自己的url 修改上面俩，不需要动这个
      let goto = encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?response_type=code&appid=${appid}&scope=snsapi_login&redirect_uri=${url}&state=STATE`)
      DDLogin({
        id: "login_container",
        goto: goto,
        style: "border:none;background-color:#FFFFFF;",
        width: "100%",//官方参数 365
        height: "300" //官方参数 400
      });
      let handleMessage = (event) => {
        let origin = event.origin;
        console.log("origin", event.origin);
        if (origin === "https://login.dingtalk.com") { //判断是否来自ddLogin扫码事件。
          let loginTmpCode = event.data;
          //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          console.log("loginTmpCode", loginTmpCode);
          //此步拿到临时loginTmpCode换取正式code
          window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${url}&loginTmpCode=${loginTmpCode}`
        }
      };
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage);
      }
    },
    async handleCodeLogin(code) {
      BoundDD({code: code}).then((data) => {
        if (data.code === 0) {
          this.ddid = data.data
          this.setUserInfo(data.data)
          // window.location.href = '/reset/pass'
          // window.location.href = '/#/reset/pass'
          this.$router.push("/reset/pass")
        }
      }).catch(err => {
        if (err.code !== 0) {
          this.ddid = ''
          this.ddLoginInit()
        }
      })
    },
    unbundle() {
      UnBoundDD().then(res => {
        this.ddid = ''
        this.ddLoginInit()
        this.setUserInfo('')
        this.$router.push("/reset/pass")
      })
    },
    submitForm() {
      if (!this.pass.trim()) this.$error('请输入正确的密码');
      resetPass({password: this.pass.trim()}).then(res => {
        this.$message.success('修改成功');
      })
    },
    setUserInfo(ddId) {
      this.$store.state.userInfo.ddid = ddId
    }
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  padding-bottom: 40px;
}
</style>